
import { Injectable } from '@angular/core';
import * as signalR from "@microsoft/signalr"
import { Notification } from '../../shared/models/common/notification';
import { environment } from '../../../environments/environment';
import { Subject } from 'rxjs';
import { SnackbarService } from './snack.service';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {

  private notificationConnection!: signalR.HubConnection;
  tripChangeSubject = new Subject<boolean>();

  constructor(private snack: SnackbarService, private tokenService: TokenService) {

  }

  public startConnection = () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      console.log('SignalR: no access token, skipping connection');
      return Promise.resolve();
    }

    if (this.notificationConnection?.state === signalR.HubConnectionState.Connected ||
        this.notificationConnection?.state === signalR.HubConnectionState.Connecting) {
      console.log('SignalR: connection already active, skipping');
      return Promise.resolve();
    }

    this.notificationConnection = new signalR.HubConnectionBuilder()
                            .withUrl(`${environment.apiUrl.replace('/api','')}notification`, {
                              withCredentials: false,
                              transport: signalR.HttpTransportType.WebSockets,
                              accessTokenFactory: () => this.tokenService.getValidAccessToken()
                            })
                            .withAutomaticReconnect({
                              nextRetryDelayInMilliseconds: (retryContext) => {
                                if (retryContext.previousRetryCount === 0) return 0;
                                if (retryContext.previousRetryCount === 1) return 2000;
                                if (retryContext.previousRetryCount === 2) return 10000;
                                return 30000;
                              }
                            })
                            .build();
    return this.tryConnect(3, 3000);
  }

  private tryConnect = (retriesLeft: number, delay: number): Promise<void> => {
    return this.notificationConnection.start()
      .then(() => { console.log('SignalR: connection started'); })
      .catch(err => {
        if (retriesLeft > 0) {
          console.log(`SignalR: connection failed, retrying in ${delay}ms... (${retriesLeft} attempts left)`);
          return new Promise<void>(resolve => setTimeout(resolve, delay))
            .then(() => this.tryConnect(retriesLeft - 1, delay));
        }
        console.log('SignalR: error while starting connection (all retries exhausted): ' + err);
        return;
      });
  }

  public stopConnection = (): Promise<void> => {
    if (!this.notificationConnection || this.notificationConnection.state === signalR.HubConnectionState.Disconnected) {
      return Promise.resolve();
    }
    this.notificationConnection.off('SendMessage');
    return this.notificationConnection
      .stop()
      .then(() => { console.log('SignalR: connection stopped'); })
      .catch(err => console.log('SignalR: error while stopping connection: ' + err));
  }

    public addTripListner = () => {
      this.notificationConnection.on('SendMessage', (notification: Notification) => {
        this.showNotification(notification);
        this.tripChangeSubject.next(true);
      });
    }

    showNotification(notification: Notification) {
      this.snack.showNotification(notification.message);
    }
}
